import { useEffect, useState } from 'react';
import WarehouseCommonApi from '../../../../../../API/warehouse/common-api';
import minus from '../../../../../../assets/media/icons/minus.svg';
import plus from '../../../../../../assets/media/icons/plus.svg';
import { TYPE_BUTTONS } from '../../../../../../constans';
import { Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../../components/Basic/Elements';
import { Input } from '../../../../../../components/Basic/Inputs';
import ReasonStockDebitPopUp from '../../../../WarehouseProducts/DebitPopUp';

const StepperInput = ({ item = {}, skladName, save = () => { }, ...props }) => {
  const [value, setValue] = useState(0);

  const [showReasonDebit, setShowReasonDebit] = useState(false);

  const onChange = async (value) => {
    await WarehouseCommonApi.addToWarehouse({ data: { sku: item.id, quantity: parseInt(value), skladName } })
      .then((r) => {
        save(r.entriedProduct);
        setValue(0);
      })
      .catch();
  };

  const clickAdd = async () => {
    if (value > 0) {
      onChange(value);
    }
  };

  const clickDebit = async () => {
    if (value > 0) {
      onChange(0 - value); // передаем отрицательное число
    }
    //setShowReasonDebit(false);
  };
  useEffect(() => {
    setValue(0);
  }, []);

  const reserved = 0; //item.sklad_data?.[skladName]?.shipment_reserved + item.sklad_data?.[skladName]?.hand_reserved;

  return (
    <Row>
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginRight: '10px' }}
        onClick={() => clickDebit()}
      >
        <Icon src={minus} width="16px" />
      </Button>
      <Input value={value} onChange={(v) => setValue(v)} style={{ width: '25px' }} center />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginLeft: '10px' }}
        onClick={clickAdd}
      >
        <Icon src={plus} width="15px" />
      </Button>
      {showReasonDebit && (
        <ReasonStockDebitPopUp clickOk={(reason) => clickDebit(reason)} close={() => setShowReasonDebit(false)} />
      )}
    </Row>
  );
};

export default StepperInput;
